import React from "react";
import { Col, Row } from "react-bootstrap";
import CartSummary from "../../../components/CartSummary";
import { useCart } from "../../../context/CartContext";
import CartItem from "../../../components/CartItem";
import "./index.scss";
import Header from "../../../components/appLayout/header";

export default function CartPage() {
  const { cartItems, total, removeFromCart, updateQuantity, clearCart } =
    useCart();

  return (
    <>
      <div className="p-md-5 p-0 pt-md-3">
        <Header />
      </div>
      <div className="container my-5 p-5 p-md-0">
        <h6 className="title-panier">Mon panier !</h6>

        <div className="row justify-content-center align-items-start">
          {/* Liste des produits */}
          <div className="col-12 col-md-8 my-4">
            {cartItems.length === 0 ? (
              <div className="panier-vide">
                <div className="d-flex align-items-center justify-content-center gap-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none">
                    <path
                      d="M10 0.5C4.48 0.5 0 4.98 0 10.5C0 16.02 4.48 20.5 10 20.5C15.52 20.5 20 16.02 20 10.5C20 4.98 15.52 0.5 10 0.5ZM11 15.5H9V9.5H11V15.5ZM11 7.5H9V5.5H11V7.5Z"
                      fill="black"
                    />
                  </svg>
                  <div className="d-flex flex-column justify-content-center">
                    <div className="title">Info</div>
                    <p>Votre panier est vide.</p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="cart-items-list">
                {/* Header uniquement sur desktop */}
                <Row className="cart-header fw-bold py-2 border-bottom d-none d-md-flex">
                  <Col md={6}>Produit</Col>
                  <Col md={2}>PU</Col>
                  <Col md={2}>Qté</Col>
                  <Col md={2}>Total</Col>
                </Row>

                {/* Liste des produits */}
                {cartItems.map((item) => (
                  <CartItem
                    key={item._id}
                    product={item}
                    onRemove={removeFromCart}
                    onQuantityChange={updateQuantity}
                  />
                ))}

                {/* Bouton vider panier */}
                <div className="mt-3">
                  <button
                    className="btn-plus w-100 w-md-auto"
                    onClick={clearCart}>
                    Vider le panier
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Résumé panier */}
          <div className="col-12 col-md-4">
            <div className="d-flex justify-content-center justify-content-md-end my-4 w-100">
              <CartSummary total={total} tva={total.toFixed(3)} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
